(ns manatee.admin.queue.handlers
  "Event handler support for the admin. queue tab."
  (:require [ajax.edn :as ajax-edn]
            [cljs.pprint :as pp]
            [kee-frame.core :as kf]
            [manatee.admin.queue.app-db :as queue-db]
            [manatee.components.notifications.handlers :as notifications]
            [manatee.session.handlers :as session-handlers]
            [re-frame.core :as rf]
            [taoensso.timbre :as log]))

(rf/reg-event-db
 ::select-queue-config
 (fn select-queue-config
   [db [_ id]]
   (queue-db/set-selected-queue-config-id db id)))

(rf/reg-event-db
 ::toggle-queue-config
 (fn toggle-queue-config
   [db [_ id]]
   (if (= id (queue-db/get-selected-queue-config-id db))
     (queue-db/set-selected-queue-config-id db nil)
     (queue-db/set-selected-queue-config-id db id))))

(rf/reg-event-db
 ::set-list-view
 (fn set-list-view
   [db [_ flag]]
   (queue-db/set-list-view db flag)))

(kf/reg-chain
 ::load-queue-configs
 (fn load-queue-configs
   [_ _]
   {:http-xhrio {:method :get
                 :uri (kf/path-for [:api/queue-configs])
                 :on-failure [::load-queue-configs-failure]
                 :response-format (ajax-edn/edn-response-format)}})
 (fn load-queue-configs-success
   [{:keys [db]} [configs]]
   {:db (queue-db/set-queue-configs db configs)}))

(rf/reg-event-fx
 ::load-queue-configs-failure
 (fn load-queue-configs-failure
   [_ [_ info]]
   (log/error "Error loading queue configs" {:info info})
   {:dispatch [::notifications/add-alert :main
               {:message "Unable to load queue configs. Refresh the browser to try again or contact support if necessary."
                :type :error}
               :auto-dismiss? false]}))

(rf/reg-event-fx
 ::upsert-queue-config
 [(rf/inject-cofx :cookie/get [:auth-token])]
 (fn upsert-queue-config
   [{:keys [db]} [_ {:keys [queue-name is-archived? queue-users task-config-id] :as _data}]]
   (let [selected-config-id (queue-db/get-selected-queue-config-id db)
         config (cond-> {:name queue-name
                         :is-archived? is-archived?
                         :users queue-users
                         :task-config-id task-config-id
                         :action "create"}
                  selected-config-id (assoc :id (str selected-config-id)
                                            :action "update"))]
     {:http-xhrio {:method :put
                   :uri (kf/path-for [:api/queue-configs])
                   :params config
                   :format (ajax-edn/edn-request-format)
                   :response-format (ajax-edn/edn-response-format)
                   :on-success [::queue-config-success config]
                   :on-failure [::queue-config-failure config]}})))

(rf/reg-event-fx
 ::queue-config-success
 (fn queue-config-success
   [{:keys [db]} [_ {:keys [name action] :as config} response]]
   (let [action (str action \d)
         message (pp/cl-format nil "Queue configuration ~A ~A successfully" name action)]
     {:db db
      :dispatch-n (cond-> [[::load-queue-configs]
                           [::notifications/add-alert :main
                            {:message message
                             :type :info}
                            :auto-dismiss? true]
                           [::session-handlers/log-events {:events [{:event-type :admin-queue-config
                                                                     :data (cond-> config
                                                                             (:id response) (assoc :id (:id response)))}]}]])})))

(rf/reg-event-fx
 ::queue-config-failure
 (fn queue-config-failure
   [{:keys [db]} [_ {:keys [action] :as _config} {:keys [response] :as _resp}]]
   (let [message (pp/cl-format nil "Unable to ~A queue configuration. Refresh the browser to try again or contact support if necessary." action)]
     {:db       db
      :dispatch [::notifications/add-alert :main
                 {:message (or (get-in response [:reason :message])
                               message)
                  :type    :error}
                 :auto-dismiss? true]})))
